import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import Sidebar from '../common/sidebar';
import Topbar from '../common/topbar';

export function Layout({ children }) {
  return (
    <Box bg="#F5F4F5">
      <Flex>
        <Sidebar />
        <Box w="100%">
          <Topbar />
          <Box p={4} minH="container.xl">
            {children}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export const noop = 'value';
